// extracted by mini-css-extract-plugin
module.exports = {"feed":"Feed_feed__1VDlB","feed_btn":"Feed_feed_btn__3rCxw","feedMain":"Feed_feedMain__21g9I"};